/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { MotherhoodStandaloneVideoPlaylist as ResolvedStandaloneVideoPlaylist } from 'sites/motherhood/components/standalone/VideoPlaylist';

export const VideoPlaylist: typeof ResolvedStandaloneVideoPlaylist = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneVideoPlaylist {...props} />
    );
});

export type VideoPlaylistProps = PropsFromComponent<typeof VideoPlaylist>;

/** @deprecated Use slot architecture instead */
export const VideoPlaylistWith = (extras: DynamicStandaloneExtras): typeof VideoPlaylist => {
    return function VideoPlaylist(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'VideoPlaylist');
        return <ResolvedStandaloneVideoPlaylist {...mergeProps({ options: { theme } }, props)} />;
    }
}